import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    list: {},
    isLoading: false,
    error: null
}

const getRetailerSlice = createSlice({
    name: 'list',
    initialState,
    reducers: {
        retailerPending: (state) => {
            state.isLoading = true;
        },
        retailerSuccess: (state, { payload }) => {
            state.isLoading = false;
            state.list = payload?.data;
            state.error = null;
        },
        retailerFail: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
        }
    }
})

export const { retailerPending, retailerSuccess, retailerFail } = getRetailerSlice.actions

export default getRetailerSlice.reducer